var _defs, _path, _path2, _polygon, _polygon2, _path3, _path4, _rect, _path5, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPantpajama01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-176,.cls-175{fill:#fff;stroke:#000;stroke-miterlimit:10;}.cls-176{stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M144,107.08c-2.38,12.22-5.43,30.15-7.55,51.94-5,51.34-1.32,88.67,1.72,124.52,1.53,18.13-.24,41.35,1.54,67.74s3.18,55.64,4.82,90c5.66-.1,15.78.77,21.52.33,5.58-.42,18-.57,23.48-1.33-3-28.43-8.51-62.66-6.57-98.67,2.78-51.48,8.73-95.81,18.71-132q.17-49.18.34-98.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M260,107.08c2.38,12.22,5.43,30.15,7.55,51.94,5,51.34,1.32,88.67-1.72,124.52-1.53,18.13.24,41.35-1.54,67.74s-.15,55.64-1.78,90c-5.67-.1-18.82.77-24.56.33-5.58-.42-16-2.57-21.44-3.33,2.94-28.43,6.47-60.66,4.53-96.67-2.78-51.48-8.73-95.81-18.71-132q-.17-49.18-.34-98.39Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "153.39 108.05 136.06 163.65 135.29 172.64 156.82 108.17 153.39 108.05"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "249.72 108.05 267.04 163.65 267.82 172.64 246.29 108.17 249.72 108.05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M215.58,108.83v51.65a12.36,12.36,0,0,1-12.17,11.38,11,11,0,0,1-1.41-.09V108.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M173.43,99.54c14.83,1.77,29,0,42.32-.44l.27,13.84c-6.82.49-12.54.68-16.75.75-11.14.19-24.73.36-41.34-2.51-6.27-1.09-11.4-2.34-14.91-3.27q1.69-6.3,3.4-12.58Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 167.29,
    y: 98.29,
    width: 4.78,
    height: 18.55,
    transform: "translate(2.3 -3.55) rotate(1.21)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M231.6,99.54c-14.82,1.77-29,0-42.32-.44a50.62,50.62,0,0,0-.26,13.84c6.81.49,12.53.68,16.74.75,11.14.19,24.73.36,41.34-2.51,6.27-1.09,11.4-2.34,14.92-3.27q-1.71-6.3-3.41-12.58Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 232.96,
    y: 98.29,
    width: 4.78,
    height: 18.55,
    transform: "translate(472.92 210.15) rotate(178.79)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPantpajama01);
export default __webpack_public_path__ + "static/media/PANT PAJAMA-01.ff8c72e1bbcd3ca04c806eb9894129b5.svg";
export { ForwardRef as ReactComponent };